/**
 * React context for the signed-in user's membership in the silo.
 *
 * The membership is `null` when no one is signed in.
 */

import type { DetailedUserProfile } from '@repo/shared/orpc/procedures/profiles';
import React from 'react';

export type SiloMember = {
    profile: Omit<DetailedUserProfile, 'roles'>;
    roles: string[];
};

export const SiloMemberContext = React.createContext<SiloMember | null>(null);
